import { getOffers, generateUserToken } from 'actions/clz/0bod';
import CircularProgressBar from 'components/common/CircularProgressBar';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { noop } from 'lodash';
import { any, func, objectOf } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { sendGAEvent } from 'utils/ga';
import { WAITING_TIMEOUT } from './constant';
import s from './style.css';

class WaitingPage extends React.Component {
  static propTypes = {
    onGetOffers: func,
    newBOD: objectOf(any),
  };
  static defaultProps = {
    onGetOffers: noop,
    newBOD: {},
  };
  constructor(props) {
    super(props);
    this.state = { seconds: WAITING_TIMEOUT };
  }
  async componentDidMount() {
    const { newBOD, onGetOffers, onGenerateUserToken } = this.props;
    const { token, user } = newBOD;
    const { cuid, id } = user;
    const userToken = await onGenerateUserToken(cuid, id, token);
    if (userToken) {
      await onGetOffers(userToken);
    }
    sendGAEvent(
      'Visit_Page',
      'Finding_Products_Page',
      'ACL_0BOD_Finding_Products',
    );
  }
  render() {
    const { seconds } = this.state;
    return (
      <div className={s.container}>
        <CircularProgressBar
          strokeWidth="10"
          sqSize="200"
          changeSecond={second => this.setState({ seconds: second })}
          seconds={seconds}
          defaultTimeout={WAITING_TIMEOUT}
        />
        <p className={s.title}>Đang tìm ưu đãi vay của bạn</p>
        <p className={s.paragraph}>
          Sẽ nhanh thôi! <br />Chúng tôi đang xử lý yêu cầu của bạn.
        </p>
        <p className={s.paragraph}>
          Đăng ký vay trực tuyến luôn tiện hơn phải chờ xét duyệt theo quy trình
          thủ công. Đừng vội đóng trình duyệt nhé!
        </p>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  onGetOffers: async userToken => {
    await dispatch(getOffers(userToken));
  },
  onGenerateUserToken: async (cuid, id, token) => {
    const userToken = await dispatch(generateUserToken(cuid, id, token));
    return userToken;
  },
});
const mapStateToProps = ({ clz }) => ({
  newBOD: clz.newBOD,
});
const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(s),
);
export default enhance(WaitingPage);
